import axios from 'axios';

import ENDPOINT from '../../context/EndPoint';

const AdminAddStudentReport = async ({payload}) => {

          const formData = new FormData();

           formData.append('session',payload.user);
           formData.append('user_id',payload.user_id);
           
           formData.append('report',payload.report);
       
           formData.append('course_url',payload.course_url);
       
           formData.append('purchase_id',payload.purchase_id);
       
           
           
           

           try{
               const res = await axios.post(ENDPOINT+"add-student-report.php", formData,{
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                });
                if(res.data){
                    return res.data
             
                }
           }
           catch(error){

return error
           }

     




}

export default AdminAddStudentReport